import { Link, Paper, Popover } from "@/common/styles/style";
import { styles } from "./style";

interface MenuPopoverProps {
  anchorEl: HTMLElement | null;
  data: {
    name: string;
    func: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  }[];
  handleMenuClose: () => void;
}

export default function MenuPopover({
  anchorEl,
  data,
  handleMenuClose,
}: MenuPopoverProps) {
  const openMenu = Boolean(anchorEl);
  return (
    <Popover
      open={openMenu}
      anchorEl={anchorEl}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Paper>
        {data.map((list, index) => (
          <Link
            key={index}
            component="button"
            sx={styles.link}
            onClick={list.func}
          >
            {list.name}
          </Link>
        ))}
      </Paper>
    </Popover>
  );
}
